import {
    OrderProductCreateDto,
    OrderProductUpdateDto,
    ProductDto, ProductPriceDto
} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import {Avatar, InputNumber, Select} from "antd";
import {useEffect, useState} from "react";
import {useForm} from "antd/es/form/Form";

const layout = {
    labelCol: {span: 7}
};

export default function OrderProductModalForm(props: OrderProductModalProps) {
    const [form] = useForm();
    const [selectedProduct, setSelectedProduct] = useState<ProductDto | null>(null);
    const [selectedUnit, setSelectedUnit] = useState<ProductPriceDto | null>(null);

    const formItems: CrudFormItemProps[] = [{
        name: nameof<OrderProductCreateDto>("productId"),
        label: "Nazwa produktu",
        rules: [
            {required: true, message: "To pole jest wymagane"}
        ],
        children: <Select onChange={(id: number) => setSelectedProduct(props.products?.find(x => x.id === id)!)}>
            {props.products?.map((product: ProductDto) => <Select.Option
                key={product.id} value={product.id}
            >
                <Avatar
                    src={props.productImage.find(x => x.productId === product.id)?.image}
                    style={{marginRight: "10px"}}
                />
                {product.name}
            </Select.Option>)}
        </Select>
    }, {
        name: nameof<OrderProductCreateDto>("unit"),
        label: "Jednostka miary",
        rules: [
            {required: true, message: "To pole jest wymagane"}
        ],
        children: <Select
            onChange={(id: number) => setSelectedUnit(selectedProduct?.prices?.find(x => x.id === id)!)}
            disabled={!selectedProduct}
        >
            {selectedProduct?.prices?.map((price: ProductPriceDto, key: number) => <Select.Option
                key={key} value={price.id} disabled={price.unitStock === 0}
            >
                {`${price.unit} ${price.unitStock === 0 ? ' - Brak w magazynie' : ''}`}
            </Select.Option>)}
        </Select>
    }, {
        name: nameof<OrderProductCreateDto>("amount"),
        label: "Ilość",
        rules: [
            {required: true, message: "To pole jest wymagane"},
            {
                validator: (_, value) => value > 0
                    ? Promise.resolve()
                    : Promise.reject(new Error("Ilość produktu musi być większa niż 0"))
            }
        ],
        children: <InputNumber disabled={!selectedUnit} min={0} max={selectedUnit?.unitStock}/>
    }];

    const onSubmit = async (values: OrderProductCreateDto) => {
        values.productName = selectedProduct?.name;
        values.unitPrice = selectedUnit?.unitValue;
        values.unit = selectedUnit?.unit;

        await props.onSubmit(values);
    }

    useEffect(() => {
        if (!selectedProduct) return;
        form.resetFields([
            nameof<OrderProductCreateDto>("amount"),
            nameof<OrderProductCreateDto>("unit")
        ]);
        setSelectedUnit(null);
    }, [selectedProduct]);

    return <CrudFormModal
        form={form}
        forceRender={true}
        destroyOnClose={true}
        formItems={formItems}
        onSubmit={onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        formProps={layout}
        modalCancelText="Anuluj"
    />;
}

export interface ProductPreviewImage {
    productId: number,
    image: string;
}

interface OrderProductModalProps {
    initialValues?: OrderProductCreateDto | OrderProductUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: OrderProductCreateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    products: ProductDto[],
    productImage: ProductPreviewImage[];
}
